module.exports = __webpack_public_path__ + "static/media/service-ecommerce-mobile.c9c1c70a.png";